import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';

@Injectable()
export class HelpCenterNestApi {

    private _service: string = 'marketplace';
    private _model: string = 'helpCenter';

    constructor(
        private nestApiProvider: NestApiProvider,
    ) {
    }

    public getHelpList(): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'helpList';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};
        const _contentType = 'json';

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
    }

    public getHelpListId(urlParams): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'helpList';
        const _params: any = {};
        const _urlParams: any = { helpId: urlParams };
        const _body: any = {};
        const _contentType = 'json';

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
    }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/help-center/help-center.ts